module.exports = __webpack_public_path__ + "img/cs-basicEduS-5.c2c31789.jpg";